import { useDataValue } from 'Simple/Data.js'
import formatISO from 'date-fns/formatISO/index.js'
import parseISO from 'date-fns/parseISO/index.js'
import subDays from 'date-fns/subDays/index.js'
import startOfDay from 'date-fns/startOfDay/index.js'
import endOfDay from 'date-fns/endOfDay/index.js'
import { useMemo } from 'react'

export default function useDataConfiguration(props) {
  let selectedLocations = useDataValue({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })

  let selectedCampaigns = useDataValue({
    context: 'tab',
    path: 'selected.campaigns',
    viewPath: props.viewPath,
  })

  let selectedConfigurations = useDataValue({
    context: 'tab',
    path: 'selected.configurations',
    viewPath: props.viewPath,
  })

  let selectedCampaignDateRange = useDataValue({
    context: 'tab',
    path: 'selected.range',
    viewPath: props.viewPath,
  })

  let showDismissed = useDataValue({
    context: 'tab',
    path: 'selected.show_dismissed',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    // default start range
    let start_date = formatISO(startOfDay(subDays(new Date(), 30)))
    let end_date = formatISO(endOfDay(new Date()))

    if (
      selectedCampaignDateRange.start_date &&
      selectedCampaignDateRange.end_date
    ) {
      start_date = formatISO(
        startOfDay(parseISO(selectedCampaignDateRange.start_date))
      )
      end_date = formatISO(
        endOfDay(parseISO(selectedCampaignDateRange.end_date))
      )
    }

    let locationsClause = {
      _or: [
        { location_id: { _in: selectedLocations } },
        { location_id: { _is_null: true } },
      ],
    }
    let datesClause = { updated_at: { _gte: start_date, _lte: end_date } }
    let campaignsClause = selectedCampaigns.length && {
      analytics: { campaign_id: { _in: selectedCampaigns } },
    }
    let configurationsClause = selectedConfigurations.length && {
      configuration_id: { _in: selectedConfigurations },
    }
    let statusClause = showDismissed
      ? { status: { _neq: ['no_data'] } }
      : { status: { _nin: ['dismissed', 'no_data'] } }

    return {
      requestPolicy: 'cache-and-network',
      variables: {
        where: {
          _and: [
            { metadata: { _contains: { person: {} } } },
            locationsClause,
            datesClause,
            campaignsClause,
            statusClause,
            configurationsClause,
          ].filter(Boolean),
        },
        where_total: {
          _and: [
            locationsClause,
            datesClause,
            campaignsClause,
            configurationsClause,
            { status: { _neq: 'patient_exists' } },
          ].filter(Boolean),
        },
        where_total_incompletes: {
          _and: [
            locationsClause,
            datesClause,
            campaignsClause,
            configurationsClause,
            { status: { _eq: 'incomplete' } },
          ].filter(Boolean),
        },
        where_total_created: {
          _and: [
            locationsClause,
            datesClause,
            campaignsClause,
            configurationsClause,
            { status: { _eq: 'created' } },
          ].filter(Boolean),
        },
        where_total_patient_created: {
          _and: [
            locationsClause,
            datesClause,
            campaignsClause,
            configurationsClause,
            { status: { _eq: 'patient_created' } },
          ].filter(Boolean),
        },
      },
      pause: !selectedLocations.length,
    }
  }, [
    selectedCampaignDateRange.end_date,
    selectedCampaignDateRange.start_date,
    selectedCampaigns,
    selectedConfigurations,
    selectedLocations,
    showDismissed,
  ])
}
